// index.htmlのviewport設定に戻す
export function resetViewport(): void {
    document.querySelector('meta[name="viewport"]')!
        .setAttribute('content', 'width=device-width,initial-scale=1')
}

// スマホ非対応画面（PC版のみ画面）の場合、デザイン崩れなく画面表示するためにviewportの横幅を1200pxに設定する
export function setViewportForPcPageOnSp(): void {
    document.querySelector('meta[name="viewport"]')!
        .setAttribute('content', 'width=1200,height=device-height')
}
